import { ColumnConfig, ColumnType } from '../Shared/Components/DataTable';
import { Company } from './Types/companyTypes';
import { Avatar, Box } from '@mui/material';
import BusinessIcon from '@mui/icons-material/Business';

import { resolveBackendOrigin } from '../../Api/apiUrl';

const API_BASE_URL = resolveBackendOrigin(process.env.REACT_APP_API_URL);

export const companyColumns: ColumnConfig<Company>[] = [
  {
    key: 'logo',
    label: 'Logo',
    render: (row) => {
      const filePath = row.images?.[0]?.filePath;
      const logoUrl = filePath ? `${API_BASE_URL}${filePath}` : undefined;

      return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Avatar
            src={logoUrl}
            alt={row.name}
            sx={{
              width: 40,
              height: 40,
              bgcolor: logoUrl ? 'transparent' : 'primary.main',
            }}
          >
            {!logoUrl && <BusinessIcon />}
          </Avatar>
        </Box>
      );
    },
  },
  {
    key: 'name',
    label: 'Nazwa',
    type: ColumnType.text,
  },
  {
    key: 'nip',
    label: 'NIP',
    type: ColumnType.text,
  },
  {
    key: 'regon',
    label: 'REGON',
    type: ColumnType.text,
  },
  {
    key: 'email',
    label: 'Email',
    type: ColumnType.text,
  },
  {
    key: 'phone',
    label: 'Telefon',
    type: ColumnType.text,
  },
  {
    key: 'street',
    label: 'Ulica',
    type: ColumnType.text,
  },
  {
    key: 'buildingNumber',
    label: 'Numer budynku',
    type: ColumnType.text,
  },
  {
    key: 'apartmentNumber',
    label: 'Numer mieszkania',
    type: ColumnType.text,
  },
  {
    key: 'postalCode',
    label: 'Kod pocztowy',
    type: ColumnType.text,
  },
  {
    key: 'city',
    label: 'Miasto',
    type: ColumnType.text,
  },
  {
    key: 'country',
    label: 'Kraj',
    type: ColumnType.text,
  },
];
